<template>
  <div class="not-found">
    <div class="content">
      <div class="code">404</div>
      <div class="divider"></div>
      <p class="msg">页面不存在</p>
      <p class="sub">你访问的页面已丢失或不存在</p>
      <button class="btn" @click="$router.push('/home')">返回首页</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.not-found {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
  background-image: linear-gradient(to right, #f0f0f0 1px, transparent 1px),
    linear-gradient(to bottom, #f0f0f0 1px, transparent 1px);
  background-size: 20px 20px;
}

.content {
  text-align: center;
}

.code {
  font-size: 120px;
  font-weight: 900;
  color: #4f46e5;
  line-height: 1;
  margin-bottom: 16px;
}

.divider {
  width: 60px;
  height: 4px;
  background: #4f46e5;
  margin: 0 auto 24px;
}

.msg {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px;
}

.sub {
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 32px;
}

.btn {
  background: #2563eb;
  color: #fff;
  border: none;
  padding: 10px 28px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn:hover { background: #1d4ed8; }
</style>
